"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpectrumAuthStatus = exports.UserLocation = exports.IngestorHeader = exports.ServerHeader = exports.ClientHeader = exports.SpectrumAuthStatus_SpectrumAuthType = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const instalogger_header_1 = require("./instalogger/instalogger_header");
const common_client_header_1 = require("./client/common_client_header");
const framedevent_1 = require("../../../data/framedevent");
const common_mesh_logger_header_1 = require("./client/common_mesh_logger_header");
/** Auth type from https://github.sc-corp.net/Snapchat/api-gateway/tree/master/containers/envoy-binary/source/filters/auth */
var SpectrumAuthStatus_SpectrumAuthType;
(function (SpectrumAuthStatus_SpectrumAuthType) {
    /** AUTH_TYPE_NA_UNSET - (for linter) */
    SpectrumAuthStatus_SpectrumAuthType[SpectrumAuthStatus_SpectrumAuthType["AUTH_TYPE_NA_UNSET"] = 0] = "AUTH_TYPE_NA_UNSET";
    /** AUTH_TYPE_SNAPTOKEN - (for linter) */
    SpectrumAuthStatus_SpectrumAuthType[SpectrumAuthStatus_SpectrumAuthType["AUTH_TYPE_SNAPTOKEN"] = 1] = "AUTH_TYPE_SNAPTOKEN";
    /** AUTH_TYPE_NOAUTH - (for linter) */
    SpectrumAuthStatus_SpectrumAuthType[SpectrumAuthStatus_SpectrumAuthType["AUTH_TYPE_NOAUTH"] = 2] = "AUTH_TYPE_NOAUTH";
    /** AUTH_TYPE_SNAP_OAUTH2 - (for linter) */
    SpectrumAuthStatus_SpectrumAuthType[SpectrumAuthStatus_SpectrumAuthType["AUTH_TYPE_SNAP_OAUTH2"] = 3] = "AUTH_TYPE_SNAP_OAUTH2";
    SpectrumAuthStatus_SpectrumAuthType[SpectrumAuthStatus_SpectrumAuthType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SpectrumAuthStatus_SpectrumAuthType = exports.SpectrumAuthStatus_SpectrumAuthType || (exports.SpectrumAuthStatus_SpectrumAuthType = {}));
function createBaseClientHeader() {
    return { header: undefined };
}
exports.ClientHeader = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.header?.$case === "instaloggerClientHeader") {
            instalogger_header_1.InstaloggerClientHeader.encode(message.header.instaloggerClientHeader, writer.uint32(10).fork()).ldelim();
        }
        if (message.header?.$case === "defaultClientHeader") {
            common_client_header_1.DefaultClientHeader.encode(message.header.defaultClientHeader, writer.uint32(18).fork()).ldelim();
        }
        if (message.header?.$case === "blizzardClientHeader") {
            framedevent_1.FrameStart.encode(message.header.blizzardClientHeader, writer.uint32(26).fork()).ldelim();
        }
        if (message.header?.$case === "defaultMeshLoggerHeader") {
            common_mesh_logger_header_1.DefaultMeshLoggerHeader.encode(message.header.defaultMeshLoggerHeader, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseClientHeader();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.header = {
                        $case: "instaloggerClientHeader",
                        instaloggerClientHeader: instalogger_header_1.InstaloggerClientHeader.decode(reader, reader.uint32()),
                    };
                    break;
                case 2:
                    message.header = {
                        $case: "defaultClientHeader",
                        defaultClientHeader: common_client_header_1.DefaultClientHeader.decode(reader, reader.uint32()),
                    };
                    break;
                case 3:
                    message.header = {
                        $case: "blizzardClientHeader",
                        blizzardClientHeader: framedevent_1.FrameStart.decode(reader, reader.uint32()),
                    };
                    break;
                case 4:
                    message.header = {
                        $case: "defaultMeshLoggerHeader",
                        defaultMeshLoggerHeader: common_mesh_logger_header_1.DefaultMeshLoggerHeader.decode(reader, reader.uint32()),
                    };
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseClientHeader();
        if (object.header?.$case === "instaloggerClientHeader" &&
            object.header?.instaloggerClientHeader !== undefined &&
            object.header?.instaloggerClientHeader !== null) {
            message.header = {
                $case: "instaloggerClientHeader",
                instaloggerClientHeader: instalogger_header_1.InstaloggerClientHeader.fromPartial(object.header.instaloggerClientHeader),
            };
        }
        if (object.header?.$case === "defaultClientHeader" &&
            object.header?.defaultClientHeader !== undefined &&
            object.header?.defaultClientHeader !== null) {
            message.header = {
                $case: "defaultClientHeader",
                defaultClientHeader: common_client_header_1.DefaultClientHeader.fromPartial(object.header.defaultClientHeader),
            };
        }
        if (object.header?.$case === "blizzardClientHeader" &&
            object.header?.blizzardClientHeader !== undefined &&
            object.header?.blizzardClientHeader !== null) {
            message.header = {
                $case: "blizzardClientHeader",
                blizzardClientHeader: framedevent_1.FrameStart.fromPartial(object.header.blizzardClientHeader),
            };
        }
        if (object.header?.$case === "defaultMeshLoggerHeader" &&
            object.header?.defaultMeshLoggerHeader !== undefined &&
            object.header?.defaultMeshLoggerHeader !== null) {
            message.header = {
                $case: "defaultMeshLoggerHeader",
                defaultMeshLoggerHeader: common_mesh_logger_header_1.DefaultMeshLoggerHeader.fromPartial(object.header.defaultMeshLoggerHeader),
            };
        }
        return message;
    },
};
function createBaseServerHeader() {
    return {
        serverTimestampMsecs: "0",
        userLocation: undefined,
        uploadTimestampMsecs: "0",
        attestationSuccess: false,
        attestationFailureReason: "",
        authStatus: undefined,
        serverUserGuid: "",
        userAgent: "",
        meshLoggerMaxSequenceId: "",
        meshLoggerInstanceId: "",
        clientIp: "",
    };
}
exports.ServerHeader = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.serverTimestampMsecs !== "0") {
            writer.uint32(8).int64(message.serverTimestampMsecs);
        }
        if (message.userLocation !== undefined) {
            exports.UserLocation.encode(message.userLocation, writer.uint32(18).fork()).ldelim();
        }
        if (message.uploadTimestampMsecs !== "0") {
            writer.uint32(24).int64(message.uploadTimestampMsecs);
        }
        if (message.attestationSuccess === true) {
            writer.uint32(32).bool(message.attestationSuccess);
        }
        if (message.attestationFailureReason !== "") {
            writer.uint32(42).string(message.attestationFailureReason);
        }
        if (message.authStatus !== undefined) {
            exports.SpectrumAuthStatus.encode(message.authStatus, writer.uint32(50).fork()).ldelim();
        }
        if (message.serverUserGuid !== "") {
            writer.uint32(58).string(message.serverUserGuid);
        }
        if (message.userAgent !== "") {
            writer.uint32(66).string(message.userAgent);
        }
        if (message.meshLoggerMaxSequenceId !== "") {
            writer.uint32(74).string(message.meshLoggerMaxSequenceId);
        }
        if (message.meshLoggerInstanceId !== "") {
            writer.uint32(82).string(message.meshLoggerInstanceId);
        }
        if (message.clientIp !== "") {
            writer.uint32(90).string(message.clientIp);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseServerHeader();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.serverTimestampMsecs = longToString(reader.int64());
                    break;
                case 2:
                    message.userLocation = exports.UserLocation.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.uploadTimestampMsecs = longToString(reader.int64());
                    break;
                case 4:
                    message.attestationSuccess = reader.bool();
                    break;
                case 5:
                    message.attestationFailureReason = reader.string();
                    break;
                case 6:
                    message.authStatus = exports.SpectrumAuthStatus.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.serverUserGuid = reader.string();
                    break;
                case 8:
                    message.userAgent = reader.string();
                    break;
                case 9:
                    message.meshLoggerMaxSequenceId = reader.string();
                    break;
                case 10:
                    message.meshLoggerInstanceId = reader.string();
                    break;
                case 11:
                    message.clientIp = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseServerHeader();
        message.serverTimestampMsecs = object.serverTimestampMsecs ?? "0";
        message.userLocation =
            object.userLocation !== undefined && object.userLocation !== null
                ? exports.UserLocation.fromPartial(object.userLocation)
                : undefined;
        message.uploadTimestampMsecs = object.uploadTimestampMsecs ?? "0";
        message.attestationSuccess = object.attestationSuccess ?? false;
        message.attestationFailureReason = object.attestationFailureReason ?? "";
        message.authStatus =
            object.authStatus !== undefined && object.authStatus !== null
                ? exports.SpectrumAuthStatus.fromPartial(object.authStatus)
                : undefined;
        message.serverUserGuid = object.serverUserGuid ?? "";
        message.userAgent = object.userAgent ?? "";
        message.meshLoggerMaxSequenceId = object.meshLoggerMaxSequenceId ?? "";
        message.meshLoggerInstanceId = object.meshLoggerInstanceId ?? "";
        message.clientIp = object.clientIp ?? "";
        return message;
    },
};
function createBaseIngestorHeader() {
    return { ghostUserId: "" };
}
exports.IngestorHeader = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.ghostUserId !== "") {
            writer.uint32(10).string(message.ghostUserId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseIngestorHeader();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.ghostUserId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseIngestorHeader();
        message.ghostUserId = object.ghostUserId ?? "";
        return message;
    },
};
function createBaseUserLocation() {
    return { country: "", city: "", region: "" };
}
exports.UserLocation = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.country !== "") {
            writer.uint32(18).string(message.country);
        }
        if (message.city !== "") {
            writer.uint32(26).string(message.city);
        }
        if (message.region !== "") {
            writer.uint32(34).string(message.region);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUserLocation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    message.country = reader.string();
                    break;
                case 3:
                    message.city = reader.string();
                    break;
                case 4:
                    message.region = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseUserLocation();
        message.country = object.country ?? "";
        message.city = object.city ?? "";
        message.region = object.region ?? "";
        return message;
    },
};
function createBaseSpectrumAuthStatus() {
    return { authType: 0 };
}
exports.SpectrumAuthStatus = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.authType !== 0) {
            writer.uint32(8).int32(message.authType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSpectrumAuthStatus();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.authType = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseSpectrumAuthStatus();
        message.authType = object.authType ?? 0;
        return message;
    },
};
function longToString(long) {
    return long.toString();
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
//# sourceMappingURL=headers.js.map